import type { FunctionComponent, MouseEventHandler, ReactNode } from 'react';
import { Fragment } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import { GlobalSearchDropdownLabel, GlobalSearchDropdownSeeMore } from '~/ui/domain/global-search/GlobalSearchDropdown';

type SeeMoreProps = {
    readonly onClick: MouseEventHandler<HTMLButtonElement>;
};

const SeeMore: FunctionComponent<SeeMoreProps> = ({ onClick }) => {
    const translate = useTranslate();

    return (
        <GlobalSearchDropdownSeeMore onClick={onClick}>
            {translate('globalsearch.see-more')}
        </GlobalSearchDropdownSeeMore>
    );
};

type DropdownSectionProps = {
    readonly children: ReactNode;
    readonly hasMore: boolean;
    readonly label: string;
    readonly onClick: MouseEventHandler<HTMLButtonElement>;
};

export const DropdownSection: FunctionComponent<DropdownSectionProps> = ({ children, hasMore, label, onClick }) => (
    <Fragment>
        <GlobalSearchDropdownLabel>{label}</GlobalSearchDropdownLabel>
        {children}
        {hasMore && <SeeMore onClick={onClick} />}
    </Fragment>
);
